import React from 'react';
import DebugOnly from 'util/dev-tools/DebugOnly';
import RenderCounter from 'util/dev-tools/RenderCounter';
import { PdfGridsArea, PdfH1, PdfP, PdfPage } from './Styles.styled';
import usePdfData from './utils/usePdfData';

const ReferencePage: React.FC = () => {
  const { epdDefinition, additionalInformation, pdfTemplateVersion } = usePdfData();
  return (
    <PdfPage>
      <DebugOnly>
        <RenderCounter componentName="ReferencesPage" threshold={3} />
      </DebugOnly>
      <PdfGridsArea>
        <div>
          <PdfH1>References</PdfH1>
          <PdfP dangerouslySetInnerHTML={{ __html: (additionalInformation?.references ?? '').replace(/\n/g, '') }} />
        </div>
        {!!epdDefinition.versionDescription && (
          <div>
            <PdfH1>Version history</PdfH1>
            <PdfP dangerouslySetInnerHTML={{ __html: (epdDefinition.versionDescription ?? '').replace(/\n/g, '') }} />
          </div>
        )}
        {!!pdfTemplateVersion && (
          <div>
            <PdfP>PDF template version {pdfTemplateVersion}</PdfP>
          </div>
        )}
      </PdfGridsArea>
    </PdfPage>
  );
};

export default ReferencePage;
